import { FunctionComponent } from 'react';

import { Controller } from 'react-hook-form';

import { IdentityUserSearchBox } from './IdentityUserSearchBox';
import { IdentityUserSearchResult } from './IdentityUserSearchBoxOptions';

type Props = {
  name: string;
  control: any;
  defaultValue?: IdentityUserSearchResult | null;
  showLabel?: boolean;
};

export const IdentityUserSearchBoxInput: FunctionComponent<Props> = ({
  name,
  control,
  defaultValue,
  showLabel,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange: onControllerChange } }) => (
        <IdentityUserSearchBox
          onSelected={result => {
            onControllerChange(result);
          }}
          defaultValue={defaultValue}
          showLabel={showLabel}
        />
      )}
    />
  );
};
